import { apiHelper } from "@/utils";
import { API } from "@/constants";

export const authService = {
	login,
	refresh,
	loginOtpRequest,
	loginOtpVerify,
	forgotPasswordOtpRequest,
	forgotPasswordOtpVerify,
	resetPasswordVerify,
	logout,
	changePassword,
};

const MODULE = {
	AUTH: "auth",
};

const API_URL = API.BASE_URL_API + "/v1";

export function login(data) {
	const request = {
		email: data.email,
		password: data.password,
		platform: 1,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login`, request);
}

export function refresh() {
	return apiHelper(API_URL, true, false).post(`/${MODULE.AUTH}/refresh`);
}

export function loginOtpRequest (data) {
	const request = {
		email: data.email,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login-otp-request`, request);
}

export function loginOtpVerify (data) {
	const request = {
		email: data.email,
		otp: data.otp,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/login-otp-verify`, request);
}

export function forgotPasswordOtpRequest (data) {
	const request = {
		email: data.email,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/forgot-password-otp-request`, request);
}

export function forgotPasswordOtpVerify (data) {
	const request = {
		email: data.email,
		otp: data.otp,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/forgot-password-otp-verify`, request);
}

export function resetPasswordVerify (data) {
	const request = {
		user_uuid: data.userUuid,
		otp: data.otp,
		password: data.password,
	};

	return apiHelper(API_URL, false, false).post(`/${MODULE.AUTH}/reset-password-verify`, request);
}

export function logout() {
	return apiHelper(API_URL).post(`/${MODULE.AUTH}/logout`);
}

export function changePassword(data) {
	return apiHelper(API_URL).patch(`/${MODULE.AUTH}/password`, {
		current_password: data.current_password,
		new_password: data.new_password,
		new_password_confirmation: data.new_password_confirmation,
	});
}
